import { connect } from 'react-redux'

import generalSelectors from 'models/General/selectors'
import generalActions from 'models/General/actions'
import profileInfoSelectors from 'models/ProfileInfo/selectors'

import NetworkError from './NetworkError'

const mapStateToProps = (state) => ({
  isNoInternetError: generalSelectors.getIsNoInternetError(state),
  isRegionCheckSuccess: generalSelectors.getIsRegionCheckSuccess(state),
  intercomUserHash: generalSelectors.getIntercomUserHashWeb(state),
  userAlias: profileInfoSelectors.getUserAlias(state),
})

const mapDispatchToProps = {
  initApp: generalActions.initApp.init,
}

export default connect(mapStateToProps, mapDispatchToProps)(NetworkError)
